<template>
	<el-dialog :title="!dataForm.testId ? '新增报验记录' : '修改报验记录'" :close-on-click-modal="false" :visible.sync="visible"
		width="800px">
		<el-form ref="dataForm" :model="dataForm" :rules="dataRule">
			<table>
				<tr>
					<td class="ttd">
						<label>
							<span>{{ dataForm.recSortCode }}</span>
						</label>
					</td>
					<td class="ttd" colspan="2">
						<label>
							<span style="color: red;">* </span>
							<span>部件</span>
						</label>
					</td>
					<td colspan="4">
						<el-input class="no-border-input" v-model="dataForm.partsName" placeholder=""></el-input>
					</td>
				</tr>
				<tr>
					<td class="ttd" colspan="2">
						<label>
							<span style="color: red;">* </span>
							<span>检验日期</span>
						</label>
					</td>
					<td colspan="2">
						<el-date-picker class="no-border-input" v-model="dataForm.testDate" type="date"
							value-format="yyyy-MM-dd" placeholder=""></el-date-picker>
					</td>
					<td class="ttd">
						<label>
							<span style="color: red;">* </span>
							<span>检验人</span>
						</label>
					</td>
					<td colspan="2">
						<el-input class="no-border-input" v-model="dataForm.testMan" placeholder=""></el-input>
					</td>
				</tr>
				<tr>
					<td class="ttd" colspan="7">
						<label>
							<span style="color: red;">* </span>
							<span class="title_middle">检验项目</span>
						</label>
					</td>
				</tr>
				<tr>
					<td colspan="7">
						<el-input class="no-border-input auto-textarea" type="textarea"
							:autosize="{ minRows: 3, maxRows: 5 }" v-model="dataForm.probContext"
							placeholder=""></el-input>
					</td>
				</tr>
				<tr>
					<td class="ttd" colspan="7">
						<label>
							<span style="color: red;">* </span>
							<span class="title_middle">检验意见</span>
						</label>
					</td>
				</tr>
				<tr>
					<td colspan="7">
						<el-input class="no-border-input auto-textarea" type="textarea"
							:autosize="{ minRows: 3, maxRows: 5 }" v-model="dataForm.sutContent"
							placeholder=""></el-input>
					</td>
				</tr>
				<tr class="title_middle">
					<td class="ttd" colspan="7">
						<label>
							<span>备注</span>
						</label>
					</td>
				</tr>
				<tr>
					<td colspan="7">
						<el-input class="no-border-input auto-textarea" type="textarea"
							:autosize="{ minRows: 3, maxRows: 5 }" v-model="dataForm.remark"></el-input>
					</td>
				</tr>
				<tr>
					<td class="ttd" colspan="7">
						<label class="title_middle">
							<span>检验结论</span>
						</label>
					</td>
				</tr>
				<tr>
					<td class="ttd" colspan="3" style="width:290px">
						<label>
							<span v-if="containCode(dataForm.recSortCode, ' ')" style="color: red;">* </span>
							<span>1次检验</span>
						</label>
					</td>
					<td class="ttd" colspan="2" style="width:230px">
						<label>
							<span v-if="containCode(dataForm.recSortCode, 'A')" style="color: red;">* </span>
							<span>2次检验</span>
						</label>
					</td>
					<td class="ttd" colspan="2" style="width:270px">
						<label>
							<span v-if="containCode(dataForm.recSortCode, 'B')" style="color: red;">* </span>
							<span>2次以上检验</span>
						</label>
					</td>
				</tr>
				<tr>
					<td colspan="3">
						<el-select class="no-border-input" v-model="dataForm.testConclusion" placeholder=""
							:disabled="!containCode(dataForm.recSortCode, ' ')">
							<el-option v-for="item in conclusionList" :key="item.displayValue" :label="item.displayName"
								:value="item.displayValue">
							</el-option>
						</el-select>
					</td>
					<td colspan="2">
						<el-select class="no-border-input" v-model="dataForm.testConclusion2" placeholder=""
							:disabled="!containCode(dataForm.recSortCode, 'A')">
							<el-option v-for="item in conclusionList" :key="item.displayValue" :label="item.displayName"
								:value="item.displayValue">
							</el-option>
						</el-select>
					</td>
					<td colspan="2">
						<el-select class="no-border-input" v-model="dataForm.testConclusion3" placeholder=""
							:disabled="!containCode(dataForm.recSortCode, 'B')">
							<el-option v-for="item in conclusionList" :key="item.displayValue" :label="item.displayName"
								:value="item.displayValue">
							</el-option>
						</el-select>
					</td>
				</tr>
			</table>
			<el-row class="formBtnGroup" style="margin-top: 5px;">
				<el-button v-preventReClick class="btn" type="primary" size="small"
					@click="dataFormSubmit()">确定</el-button>
				<el-button v-preventReClick class="btn" type="primary" size="small"
					@click="visible = false">取消</el-button>
			</el-row>
		</el-form>
	</el-dialog>
</template>
<script>
import img001 from "@/assets/images/001.jpg"
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
export default {
	name: "information-add-or-update",
	data() {
		return {
			category: '',
			action: "",
			conclusionList: [],
			subjectList: [],
			importantList: [],
			majorList: [],
			testTypeList: [],
			addImg: addImg,
			visible: false,
			recSortEdit: false,
			form: {},
			dataForm: {
				workNo: $common.getItem("workNo"),
				testId: '',
				subjectNo: "",
				recSortCode: '',
				major: '',
				applyDate: '',
				applyMan: '',
				testConclusion: '',
				testConclusion2: '',
				testConclusion3: '',
				testDate: '',
				testMan: '',
				probContext: '',
				testTimes: 1,
				category: '',
				partsName: '',
				remark: ''
			},
			dataRule: {
			}
		};
	},
	methods: {
		getCurrentTime() {
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},
		init(id, category, subjectNo, major, recSortNum) {
			this.getConclusion();
			this.dataForm = {
				workNo: $common.getItem("workNo"),
				recSortCode: '',
				subjectNo: subjectNo,
				major: major,
				applyDate: '',
				applyMan: '',
				testConclusion: '',
				testConclusion2: '',
				testConclusion3: '',
				testDate: '',
				testMan: '',
				probContext: '',
				testTimes: 1,
				category: category,
				partsName: '',
				remark: ''
			}
			this.dataForm.testId = id ? id : '';
			this.category = category;
			this.dataForm.applyDate = this.getCurrentTime();
			this.dataForm.applyMan = $common.getItem("userName");
			this.dataForm.testMan = $common.getItem("userName");
			this.dataForm.testDate = this.getCurrentTime();
			this.getMajorList()
			if (recSortNum === null || recSortNum === undefined || recSortNum === '') {
				if (id) {
					// 修改
					this.getDetail();
				} else {
					// 新增
					this.getLastRecord();
				}
			} else  {
				// NO连续性检查
				this.$set(this.dataForm, 'recSortCode', recSortNum)
			}
			this.$nextTick(() => {
				this.visible = true;
				this.$nextTick(() => {
					if (this.$refs["dataForm"]) {
						this.$refs["dataForm"].resetFields();
					}
				});
			});
		},
		containCode(recSortCode, code) {
			var sortCode = recSortCode + "";
			var numReg = /^[0-9]+$/
			var numRe = new RegExp(numReg)
			if (numRe.test(sortCode) && code == ' ') {
				return true;
			} else if (sortCode.indexOf(code) != -1) {
				return true;
			} else {
				return false;
			}
		},
		getNextRecCode(index) {
			console.log('getNextRecCode subjectNo', this.dataForm.subjectNo)
			console.log('getNextRecCode major', this.dataForm.major)
			let _url = "/business/testrecord/getNextRecCode";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					subjectNo: this.dataForm.subjectNo,
					major: this.dataForm.major,
					category: this.category,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$set(this.dataForm, 'recSortCode', data.body)
					if (this.dataForm.recSortCode === '') {
						this.dataForm.recSortCode = '1'
					}
				}
			});
		},
		getMajorList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getMajorByWorkNo/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.majorList = data.body;
				}
			});
		},
		getDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/info/" + this.dataForm.testId,
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body
					if (!this.dataForm.testMan) {
						this.dataForm.testMan = $common.getItem("userName");
					}
				}
			});
		},
		getLastRecord() {
			let _url = "/business/testrecord/getLastRecord";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: this.dataForm.workNo,
					category: this.dataForm.category,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// this.dataForm.subjectNo = data.body.subjectNo
					// this.dataForm.major = data.body.major
					// this.dataForm.testType = data.body.testType
					if (this.dataForm.subjectNo && this.dataForm.major) {
						this.getNextRecCode();
					}
				}
			});
		},
		getConclusion() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getInspectionConclusion",
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.conclusionList = data.body;
				}
			});
		},
		delImg(index) {
			let _list = this.dataForm.list;
			_list.splice(index, 1);
			this.dataForm.list = _list;
		},
		uploadImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
				formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			},
			).then(res => {
				res = res.data
				if (res.resultCode == 200) {
					this.dataForm.list.push({
						photoName: res.body.fileName,
						photoPath: res.body.fileSavePath,
						photoPathUri: res.body.fileUri
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		dataFormSubmit() {
			if (this.dataForm.subjectNo == null || this.dataForm.subjectNo == "") {
				this.$message.error("请选择标的物");
				return;
			}

			if (this.dataForm.major == null || this.dataForm.major == "") {
				this.$message.error("请选择专业");
				return;
			}

			if (this.dataForm.probContext == null || this.dataForm.probContext == "") {
				this.$message.error("请填写检验项目");
				return;
			}
			if (this.dataForm.sutContent == null || this.dataForm.sutContent == "") {
				this.$message.error("请填写检验意见");
				return;
			}

			var partsNameAndProbContext = this.dataForm.partsName + this.dataForm.probContext;
			if (partsNameAndProbContext == null || partsNameAndProbContext == '') {
				this.$message.error("部件和检验项目不能都为空！");
				return;
			}

			if (this.dataForm.testDate == null || this.dataForm.testDate == "") {
				this.$message.error("请填写检验日期");
				return;
			}

			if (this.dataForm.testMan == null || this.dataForm.testMan == "") {
				this.$message.error("请填写检验人");
				return;
			}

			if (this.dataForm.testConclusion == '' && this.dataForm.testConclusion2 == '' && this.dataForm.testConclusion3 == '') {
				this.$message.error("请填写检验结论");
				return;
			}
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let _url = "/business/testrecord/saveOrUpdate";
					this.$http({
						url: this.$store.state.httpUrl + _url,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({
						data
					}) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.visible = false;
									this.$parent.getDataList();
								}
							});
						}
					});
				}
			});
		},
	}
};
</script>
<style lang="scss" scoped="scoped">
table {
	border-collapse: collapse;
	width: 100%;
}

th,
td {
	border: 1px solid #dadada;
	padding: 2px;
	text-align: center;
	font-size: 14px !important;
}

.ttd {
	background-color: #E1F1FF;
	width: 15%;
	text-align: center;
	padding: 8px 15px;
	color: #00428E !important;
	font-size: 12px;
	font-weight: bold;
}

.set_data {
	display: inline-block;
	line-height: 1.4;
	margin: 0 !important;
	padding: 2px 5px !important;
	min-height: 22px;
	font-size: 12px;
}

.no-border-input {
	width: 100%;
}

::v-deep(.no-border-input .el-input__inner) {
	border: none !important;
	box-shadow: none !important;
	border-radius: 0 !important;
	background: transparent !important;
	padding: 0 8px !important;
	height: 32px !important;
	line-height: 32px !important;
	font-size: 14px !important;
}

::v-deep(.no-border-input.is-disabled .el-input__inner) {
	background-color: #f5f7fa !important;
	color: #606266;
}

::v-deep(.no-border-input .el-input__prefix) {
	left: 8px;
}

::v-deep(.no-border-input .el-input__suffix) {
	right: 8px;
}

::v-deep(.no-border-input .el-input__clear) {
	right: 8px;
}

::v-deep(.no-border-input .el-input__icon) {
	line-height: inherit;
}

::v-deep(.no-border-input.el-date-editor) {
	width: 100% !important;
}

::v-deep(.no-border-input.el-date-editor .el-input__inner) {
	border: none !important;
	box-shadow: none !important;
	background: transparent !important;
	padding: 0 8px !important;
}

::v-deep(.no-border-input.el-date-editor .el-input__prefix) {
	display: none;
}

::v-deep(.no-border-input.el-date-editor .el-input__suffix) {
	right: 8px;
}

::v-deep(.no-border-input.el-select) {
	width: 100% !important;
}

::v-deep(.no-border-input.el-select .el-input) {
	height: 32px !important;
	line-height: 32px !important;
}

::v-deep(.no-border-input.el-select .el-input__inner) {
	border: none !important;
	box-shadow: none !important;
	background: transparent !important;
	background-color: transparent !important;
	height: 32px !important;
	line-height: 32px !important;
	font-size: 14px !important;
	padding: 0 24px 0 8px !important;
}

::v-deep(.no-border-input.el-select .el-input.is-disabled .el-input__inner),
::v-deep(.no-border-input.el-select.is-disabled .el-input__inner) {
	background: #f5f7fa !important;
	background-color: #f5f7fa !important;
	color: #c0c4cc !important;
	cursor: not-allowed;
}

::v-deep(.no-border-input.el-select.is-disabled .el-select__selected-item) {
	color: #c0c4cc !important;
}

::v-deep(.no-border-input.el-select.is-disabled .el-input__suffix .el-select__caret) {
	border-top-color: #c0c4cc !important;
	border-bottom-color: #c0c4cc !important;
}

::v-deep(.no-border-input.el-select .el-select__selected-item) {
	line-height: 32px !important;
	height: 32px !important;
	display: flex !important;
	align-items: center !important;
}

::v-deep(.no-border-input.el-select .el-input__inner::placeholder) {
	line-height: 32px !important;
}

::v-deep(.no-border-input.el-select .el-input__suffix) {
	right: 10px;
	top: 0 !important;
	height: 32px !important;
	line-height: 32px !important;
	display: flex !important;
	align-items: center;
}

::v-deep(.no-border-input.el-select .el-input__suffix .el-select__caret) {
	display: inline-block !important;
	position: static !important;
}

::v-deep(.no-border-input.el-select .el-input__suffix .el-select__arrow) {
	display: none !important;
}

.auto-textarea {
	width: 100%;
}

::v-deep(.auto-textarea .el-textarea__inner) {
	border: none !important;
	box-shadow: none !important;
	background: transparent !important;
	resize: none !important;
	padding: 4px 8px !important;
	line-height: 1.5 !important;
	min-height: 32px !important;
	max-height: 150px !important;
	overflow-y: auto !important;
}

::v-deep(.auto-textarea.is-focus .el-textarea__inner) {
	border: none !important;
	box-shadow: none !important;
}

.title_middle {
	text-align: center;
}
</style>